// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cancel-button {\n  margin-right: 16px;\n}\n.dialog-content {\n  width: 25% !important;\n}\n.exp-time {\n  font-size: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
